import styled from "styled-components";

export const LoadingContainer = styled.div`
  background: #eaecf5;
  color: #586368;
  display: grid;
  place-items: center;
  min-height: calc(100vh - 122px);
`;

export const LoadingText = styled.div`
  transform: translateY(-120px);
  font-size: 13px;
  display: flex;
  flex-direction: ${({ direction }) => direction};
  align-items: center;
  gap: 10px;
`;

export const LoadingButton = styled.div`
  display: flex;
  align-items: center;
`;
